var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brandActivity"},[(!_vm.isIndex)?_vm._l((_vm.brandActivity),function(item,index){return _c('ActivityStyle',{key:item.id,attrs:{"showData":item,"showIndex":index}})}):_vm._l((_vm.brandActivity),function(item,index){return _c('WapActivityStyle',{key:item.id,attrs:{"showData":item,"showIndex":index}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }